export const IMPORT_DATASET = 'Import dataset. Source:';
export const RENDER_MAP_LAYER_TYPE = 'Render map layer type:';
export const FILTER_VISUALISATIONS_BY_DATASET_IN_DASHBOARD = 'Filter visualisations by dataset in dashboard editor';
export const EXPORT_EMBED_CODE = 'Get embed code';
export const SELECT_MAP_LAYER_TYPE = 'Selected map layer type';
export const SHARE_DASHBOARD = 'Share dashboard';
export const EXPORT_DASHBOARD_PNG = 'Export dashboard (png)';
export const EXPORT_DASHBOARD_PDF = 'Export dashboard (pdf)';
export const SHARE_VISUALISATION = 'Share visualisation';
export const EXPORT_VISUALISATION_PNG = 'Export visualisation (png)';
export const EXPORT_VISUALISATION_PDF = 'Export visualisation (pdf)';
export const TRANSFORM_DATASET = 'Transform dataset';
export const SELECT_VISUALISATION_TYPE = 'Select vis type:';
export const DASHBOARD_FILTER_CHANGE = 'Change dashboard filter';
export const USE_DATA_GROUPS = 'Switch data grid view';



// WEBPACK FOOTER //
// ./src/constants/analytics.js